
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19 19V9.978l-7-5.444-7 5.444V19h14zM3.772 8.4A2 2 0 003 9.977V19a2 2 0 002 2h14a2 2 0 002-2V9.978a2 2 0 00-.772-1.579l-7-5.444a2 2 0 00-2.456 0l-7 5.444z","fill":"#fff"}})])
      }
    
      }
    